import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconKey } from '../../../../../whitelabel/icon-key.enum';
import { IconPipe } from '../../../../shared/pipes/icon.pipe';
import { IconSize } from '../../icon/icon/contract/icon-size.contract';
import { IconComponent } from '../../icon/icon/icon.component';
import { TooltipDirective } from '../../overlay/tooltip/tooltip.directive';

@Component({
  selector: 'osp-tooltip-icon',
  standalone: true,
  imports: [TooltipDirective, IconComponent, IconPipe],
  templateUrl: './tooltip-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipIconComponent {
  readonly IconKey = IconKey;

  @Input() tooltipText?: string;
  @Input() tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() iconSize: IconSize = 'medium';
}
